import { Text } from "@mantine/core";
import classes from "./PlanBadge.module.css";

const PLAN_LABEL = {
	free: "Free",
	pro: "Pro",
	max: "Max",
	early_access: "Early Access",
};

/**
 * @param {Object} props
 * @param {keyof typeof PLAN_LABEL} props.plan
 * @param {"sm" | "md"} [props.size="md"]
 */
export default function PlanBadge({ plan, size = "md" }) {
	const label = PLAN_LABEL[plan] ?? plan;
	if (!label) return null;
	return (
		<Text
			component="span"
			fw="bold"
			className={`${classes.badge} ${classes[plan] ?? ""} ${classes[size] ?? ""}`}
		>
			<span className={classes.shimmer} aria-hidden="true" />
			<span className={classes.label}>{label}</span>
		</Text>
	);
}
